import styled from "styled-components";

export const HeatmapChartBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;

  .echarts-for-react {
    height: 20px !important;
  }
`;

export const HeatmapLabel = styled.div`
  color: ${(props) => props.theme.colors.black80};
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.1rem;
`;
